module.exports = __webpack_public_path__ + "static/img/Gianni-Stensness.02a67ae.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Gianni-Stensness.jpg
// module id = Cjju
// module chunks = 0